(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const countdownDeadlines = new Map();
  let countdownInterval;
  const readDeadline = key => {
    try {
      const value = Number(window.localStorage.getItem(key));
      return Number.isFinite(value) && value > 0 ? value : null;
    } catch (_) { return null; }
  };
  const updateCountdowns = () => {
    let running = false;
    document.querySelectorAll('[data-countdown]').forEach(timer => {
      const deadline = countdownDeadlines.get(timer.dataset.countdownKey);
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      if (!Number.isFinite(remaining) || remaining === 0) { timer.hidden = true; return; }
      running = true;
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor(remaining % 3600 / 60);
      const seconds = remaining % 60;
      timer.querySelector('[data-countdown-hour]').textContent = String(hours).padStart(2, '0');
      timer.querySelector('[data-countdown-minute]').textContent = String(minutes).padStart(2, '0');
      timer.querySelector('[data-countdown-second]').textContent = String(seconds).padStart(2, '0');
      timer.querySelector('[role="timer"]').setAttribute('aria-label', `${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);
      timer.hidden = false;
    });
    if (!running && countdownInterval) { clearInterval(countdownInterval); countdownInterval = undefined; }
  };
  const initialiseCountdowns = () => {
    document.querySelectorAll('[data-countdown]').forEach(timer => {
      const key = timer.dataset.countdownKey;
      if (!key || countdownDeadlines.has(key)) return;
      const hours = Math.min(24, Math.max(1, Number(timer.dataset.countdownHours) || 6));
      const stored = readDeadline(key);
      const deadline = stored === null ? Date.now() + hours * 3600000 : stored;
      countdownDeadlines.set(key, deadline);
      if (stored === null) {
        try { window.localStorage.setItem(key, String(deadline)); } catch (_) { /* The current visit still has a stable deadline. */ }
      }
    });
    if (!countdownInterval) countdownInterval = setInterval(updateCountdowns, 1000);
    updateCountdowns();
  };
  window.addEventListener('storage', event => {
    if (!countdownDeadlines.has(event.key)) return;
    const deadline = readDeadline(event.key);
    if (deadline !== null) countdownDeadlines.set(event.key, deadline);
    initialiseCountdowns();
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateCountdowns(); });
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('.mobile-menu');
  const closeMenu = () => {
    if (!toggle || !menu) return;
    toggle.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
    document.body.classList.remove('menu-open');
  };
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const opening = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(opening));
      menu.hidden = !opening;
      document.body.classList.toggle('menu-open', opening);
    });
    menu.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !menu.hidden) { closeMenu(); toggle.focus(); }
    });
    window.matchMedia('(min-width: 901px)').addEventListener('change', e => { if (e.matches) closeMenu(); });
  }
  const initialiseLanding = () => {
    const landing = document.querySelector('.hero');
    if (!landing || landing.dataset.initialised) return;
    landing.dataset.initialised = 'true';
    const primaryLink = landing.querySelector('[data-purchase-link]');
    const headerLink = document.querySelector('[data-header-purchase-link]');
    if (headerLink) {
      if (primaryLink) { headerLink.href = primaryLink.href; headerLink.textContent = primaryLink.textContent; }
      else { headerLink.href = document.querySelector('#buy') ? '#buy' : headerLink.dataset.fallbackUrl; headerLink.textContent = 'View the guide'; }
    }
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      const main = gallery.querySelector('[data-gallery-main]');
      const image = gallery.querySelector('[data-gallery-image]');
      const caption = gallery.querySelector('[data-gallery-caption]');
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      if (!main || !image || !caption) return;
      thumbs.forEach(thumb => thumb.addEventListener('click', () => {
        image.src = thumb.dataset.gallerySrc;
        image.alt = 'Actual product page: ' + thumb.dataset.galleryTitle;
        main.href = thumb.dataset.gallerySrc;
        main.dataset.previewSrc = thumb.dataset.gallerySrc;
        main.dataset.previewTitle = thumb.dataset.galleryTitle;
        caption.textContent = thumb.dataset.galleryTitle;
        thumbs.forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      }));
    });
    const modal = document.querySelector('[data-preview-modal]');
    const modalImage = document.querySelector('[data-preview-modal-image]');
    const close = document.querySelector('[data-preview-close]');
    const caption = document.querySelector('[data-preview-caption]');
    const original = document.querySelector('[data-preview-original]');
    let opener;
    const closeModal = () => {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('preview-open');
      modalImage.removeAttribute('src');
      original.removeAttribute('href');
      if (opener && opener.isConnected) opener.focus({preventScroll:true});
    };
    if (modal && modalImage && close && caption && original) {
      document.querySelectorAll('[data-preview-src]').forEach(link => {
        link.addEventListener('click', e => {
          if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          closeMenu();
          opener = link;
          modalImage.src = link.dataset.previewSrc;
          modalImage.alt = link.querySelector('img')?.alt || 'PDF page preview';
          caption.textContent = link.dataset.previewTitle || 'Page preview';
          original.href = link.dataset.previewSrc;
          modal.hidden = false;
          document.body.classList.add('preview-open');
          close.focus({preventScroll:true});
        });
      });
      close.addEventListener('click', closeModal);
      modal.addEventListener('click', e => {
        if (e.target === modal || e.target.classList.contains('preview-image-wrap')) closeModal();
      });
      modal.addEventListener('keydown', e => {
        if (e.key === 'Escape') { e.preventDefault(); closeModal(); }
        if (e.key === 'Tab') {
          if (e.shiftKey && (document.activeElement === original || document.activeElement === modal)) {
            e.preventDefault(); close.focus();
          } else if (!e.shiftKey && document.activeElement === close) {
            e.preventDefault(); original.focus();
          }
        }
      });
    }
    const rail = document.querySelector('[data-preview-rail]');
    const controls = document.querySelector('[data-preview-controls]');
    if (rail && controls) {
      const previous = controls.querySelector('[data-rail-prev]');
      const next = controls.querySelector('[data-rail-next]');
      controls.hidden = false;
      const updateControls = () => {
        previous.disabled = rail.scrollLeft <= 3;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
      };
      const move = direction => {
        const card = rail.querySelector('.preview-item');
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 20;
        rail.scrollBy({left:direction * ((card?.getBoundingClientRect().width || 260) + gap),behavior:reducedMotion.matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', updateControls, {passive:true});
      window.addEventListener('resize', updateControls);
      updateControls();
    }
    const bar = document.querySelector('[data-mobile-buy-bar]');
    if (bar && 'IntersectionObserver' in window) {
      document.body.classList.add('has-mobile-buy-bar');
      const heroCTA = landing.querySelector('.hero-cta-row');
      const offerCTA = document.querySelector('#buy [data-purchase-link]');
      let heroIsVisible = true;
      let offerIsVisible = false;
      const refreshBar = () => { bar.hidden = heroIsVisible || offerIsVisible; };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === heroCTA) heroIsVisible = entry.isIntersecting;
          if (entry.target === offerCTA) offerIsVisible = entry.isIntersecting;
        });
        refreshBar();
      }, {threshold:0,rootMargin:'-70px 0px 0px 0px'});
      if (heroCTA) observer.observe(heroCTA);
      if (offerCTA) observer.observe(offerCTA);
    }
  };
  initialiseLanding();
  initialiseCountdowns();
  document.addEventListener('shopify:section:load', initialiseLanding);
  document.addEventListener('shopify:section:load', initialiseCountdowns);
})();
